import { scaleOrdinal } from 'd3-scale'
import { schemePaired } from 'd3-scale-chromatic'

export function getOrdinalColorScale(domain: string[]) {
  const scale = scaleOrdinal(domain, schemePaired)
  return ({ id }: { id: string }) => scale(id)
}
